import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ICompanyModel } from '@apps-common/types/management/company'

export const MANAGEMENT_QUERY_KEY_GET_COMPANY = (companyId?: string) => ['getCompany', companyId].filter(Boolean)

export const getCompany = async (companyId: string): Promise<ICompanyModel> =>
  axios.get(`/management/company/getcompany?companyId=${companyId}`).then((res) => res.data?.data)

type QueryFnType = typeof getCompany

type Props = {
  config?: QueryConfig<QueryFnType>
  companyId: string
}

export const useManagementGetCompany = ({ config, companyId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: MANAGEMENT_QUERY_KEY_GET_COMPANY(companyId),
    queryFn: () => getCompany(companyId)
  })
